<template>
	<div class="h-full">
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
			staticMode="true"
		>
		</TopAppBar>
		<div class="d-flex flex-column h-full">
			<TopAppBarDrawer></TopAppBarDrawer>
			<component :is="isListType" v-if="nameRoute === 'IndependentExam'"></component>
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
		</div>
	</div>
</template>

<script>
/**
 * 단독시험 메인 컴포넌트(independent exam main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import {topAppBarMixin} from '@/mixins/topAppBar.js'

export default {
	name: 'exam',
	components: {
		'total': () => import('@/components/independentExam/list/Total.vue'),
		'my': () => import('@/components/independentExam/list/My.vue'),
		'result': () => import('@/components/independentExam/list/Result.vue'),
		'category': () => import('@/components/independentExam/list/Category.vue'),
		TopAppBar,
		TopAppBarDrawer
	},

	data() {
		return {
			listType: 'total',
			nameRoute: 'IndependentExam'
		}
	},

	mixins: [topAppBarMixin],

	computed: {
		isListType() {
			return this.$route.query.listType || 'total'
		}
	},

	watch: {
		$route (to, from){
			if(this.isListType === 'category' ){
				this.setTopAppBarBackToMyIndependent(localStorage.getItem('brandName'))
			} else {
				this.setTopAppBarHomeSearch(localStorage.getItem('brandName'))
			}
		}
	},
	mounted() {
		// set header title
		let learnBack = localStorage.getItem("mytest")
		if(this.isListType === 'category') {
			this.nameRoute =  this.$route.name;
			this.setTopAppBarBackToMyIndependent(localStorage.getItem('brandName'))
		} else {
		  this.nameRoute =  this.$route.name;
      if(this.$route.name === 'IndependentExam') {
	     this.listType = this.$route.query.listType || "total";
	     } else {
        this.listType = false
	  }
    this.setTopAppBarHomeSearch(localStorage.getItem('brandName'))
		}
		const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
			let ripple = new MDCRipple.attachTo(el)
			return ripple
		})
	},

	methods: {
		changeMode(mode) {
			this.listType = mode
		}
	}
}
</script>
